import React,{useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box , Button,Card,Typography, TextField, FormControl, InputLabel,
    Select, MenuItem
} from '@material-ui/core';
import axios from 'axios';
import Progress from "../Generales/Progress";
import { useHistory } from "react-router-dom";
 
import Modal from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {apiFDataHeader, ErrorGeneral, llamaApiCargaToken } from '../funciones/ClienteAxios';
import { v4 as uuidv4 } from 'uuid';
import qs from 'qs';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { printConsole } from '../funciones/ConsolaLog';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      },         
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));
const ModalArchivo = ({modalAbierto,setModalAbierto,titulo,registro,llenarListFile}) => {
    const history = useHistory();
    const classes = useStyles();
    const source = axios.CancelToken.source();      
    const idusu= localStorage.getItem('UsuId');    
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    const [espera,setEspera]=useState(false);
    const [mensaje, setMensaje] = useState('');
    const [tipoAdvertencia, setTipoAdvertencia] = useState('success');  
    const [aviso, setAviso] = useState(false);      
    const [btnDeshabilitado, setBtnDeshabilitado] = useState(true);      
    const [arraySubidos,setArraySubidos] = useState([])
    const [arrayPreview,setArrayPreview] = useState([])        
    const [progresoEnvio, setProgresoEnvio] = useState(0);
    const [nombreArchivo, setNombreArchivo] = useState("")
    const [descripcion, setDescripcion] = useState("")
    const [listTipo,setListTipo]= useState([]) 
    const [tipo, setTipo] = useState("")
    useEffect(()=>{             
        getListTipo()
        return ()=> {
            source.cancel();
        }     
        
    },[]);

    const getListTipo = () => {    
        const data = qs.stringify({
            Usuario:idusu,                
            idDispositivo: auxDispV
        });
        const url = "/maquinaria/seguro/file/tipo";

        function respuesta(auxiliar) 
        { 
            if (auxiliar[0].Id !== -1) 
            {                 
                setListTipo(auxiliar)
            }
        }
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    };

    const llenarListEvid = () => {               
        let bodyFormData = new FormData();
        bodyFormData.append('idDispositivo',auxDispV)
        bodyFormData.append('Llave',registro.Id)
        bodyFormData.append('Usuario',idusu)
        bodyFormData.append('Descr',descripcion)
        bodyFormData.append('Tipo',tipo)
        let auxSize=0
        arraySubidos.forEach((img)=>{
            auxSize=auxSize+img.size
            bodyFormData.append('multiFiles',img)
        })              

        const headers = {
            "size":auxSize, "tipo":"SPACE",
            "clase":"SEGURO",
            "seguro":registro.Id,
           // "llave":registro.Id,
        } 
        const url = "/maquinaria/seguro/file/envio";
        function respuesta(auxiliar) 
        {
            if (auxiliar.success===true) 
            {
                setProgresoEnvio(0)
                let mensaje="Se envio correctamente el archivo "+nombreArchivo.corto
                setTipoAdvertencia("success")      
                setMensaje(mensaje);
                setAviso(true)     
                toast.success(`${mensaje}`,{
                    pauseOnFocusLoss: false,
                    theme: "colored",
                    toastId: `exito-env`
                })  
                llenarListFile()
                setModalAbierto(false)                        
            }       
        }    
        apiFDataHeader(bodyFormData, url,respuesta,ErrorGeneral,setEspera,history,source,headers,setProgresoEnvio);
    }  

    function reemplazo(cadena) {
        let nvo=cadena
        const exPermitidaNombrePubli = new RegExp('[$@#&%+()/:;!?,<>=]')
        const prb = "[$@#&+()/%:;!?,<>=]"
        for (let index = 0; index < prb.length; index++) 
        {
            const element = prb[index];
            while (nvo.indexOf(element)!== -1) 
            {   nvo = nvo.replace(exPermitidaNombrePubli, "")                                         
            }                    
        }
        while (nvo.indexOf(" ")!== -1) 
        {   nvo = nvo.replace(" ", "")                                         
        }   
        return(nvo)
    }
    

    function onChangeArchivos2(event){
        setArrayPreview([])
        setArraySubidos([])
        setNombreArchivo("")
        const regex = /([a-zA-Z0-9\s_\.\-\(\):])+(.pdf|.doc|docx|jpg|jpeg|png|svg|webp|xlsx)$/
        let arrArch = [] ,arrArch2 = []
        let arrPrev=[]
        let valido = true;
        let limite=event.target.files.length <= 3 ? event.target.files.length :3 
        for (let i =0;i <limite ;i++){
            let img = event.target.files[i]
            let auxCode = uuidv4();
            let nom ="";      
            const tamanio= img?.size/1000000
            //console.log(img.size, img.size/1000000, tamanio<=10.0);            
            if(img.name.length>=25)
            {   nom =  img.name.substring(0,24)+"..."+img.name.substring(img.name.lastIndexOf("."),img.name.length);
            }
            else
            {   nom = img.name;
            }
            if( img && img.name.toLowerCase().match(regex) && tamanio<=10.0)
            {   //let auxNombre = auxCode + img.name.slice(img.name.lastIndexOf("."), img.name.length);
                let auxNombre =reemplazo(img.name);                
               arrArch.push(img)
               let myNewFile = new File([img], auxNombre, { type: img.type });   
               arrArch2.push(myNewFile)
               arrPrev.push(URL.createObjectURL(img))
               setNombreArchivo({corto:auxNombre,completo:img.name})
               setBtnDeshabilitado(false)
            }
            else
            {   
                let mensaje=`Formato de archivo incorrecto en ${nom} seleccione un tipo pdf, doc, docx, excel.`
                if (tamanio>10.0) {
                    mensaje=`El tamaño del archivo debe ser menor a 10mb.`
                }
                toast.warning(mensaje,{
                    pauseOnFocusLoss: false,
                    theme: "colored",
                    toastId: `incorrecto-sel`
                  }); 
                  valido=false;
                  setArraySubidos([])
                  break;
            }
        }
        if(valido)
        {   setArraySubidos(arrArch2)
            setArrayPreview(arrPrev)
        }
    }    
  
    const onChange=(e)=>{    
        setDescripcion(e.target.value)     
    }

    const onChaneTipo = e =>
    {
        setTipo( e.target.value )
    };

    function borrarArchivo(){
        setArrayPreview([]) 
        setBtnDeshabilitado(true)
        setNombreArchivo("")
    }

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;               
        if( (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null ))
            || campo === null
        ) 
        { let mensaje='No se lleno el campo '+descripcion      
          toast.warning(`${mensaje}`,{
            pauseOnFocusLoss: false, theme: "colored",
            toastId: `error-env ${2}`
          })  
        
          respuesta =true
        }    
        return(respuesta);
    }

    const verifiArchivo=()=>{
        let respuesta =false;    
        if (arraySubidos.length!==0) {
            respuesta=true
        }  
        else{
            const mensaje=`Debe seleccionar un archivo para subir`
            toast.warning(mensaje,{
                pauseOnFocusLoss: false,
                theme: "colored",
                toastId: `incorrecto-sel`
            }); 
        }         
        return(respuesta);
    }

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    //console.log("aqui");
    
    if (valor!= null && valor!= '' && valor!== '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    {    toast.warning(mensaje,{
            pauseOnFocusLoss: false,
            theme: "colored",
            toastId: `incorrecto-sel`
        });   
    }
    return respuesta
  }

    const guardarDatos = () => 
    {   if ( verifiArchivo() && !verificaNulos(descripcion,"Descripción")&& validaDatos(tipo,"Debe seleccionar un Tipo")) 
        {  //console.log(tipo);
        
            llenarListEvid();    
        }   
        
    };

    const selectTipo= <FormControl style={{   marginRight:1+'rem'}} fullWidth size="small">
      <InputLabel id="demo-select-small" variant='outlined' >Tipo</InputLabel>
      <Select
        labelId="demo-select-small" id="demo-select-small" name="tipo"
        value={tipo} label="Tipo" onChange={onChaneTipo}  variant='outlined'
      >      
        {listTipo.map((tipo)=> {
          
            return<MenuItem value={tipo.Id}>{tipo.Descr}</MenuItem>    
         
        })}
      </Select>
    </FormControl>

    let accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    //accept=accept+",application/x-rar-compressed,application/x-rar,application/octet-stream,application/zip,application/x-zip"
    accept=accept+",image/jpg,image/jpeg,image/png,image/svg,image/webp,application/xlsx, .xlsx"
    
  return (
    <Modal
        titulo={`Agregar Archivo a la Poliza ${registro.Poliza}`} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        tamanio="md" btnDesact={btnDeshabilitado} cargando={espera}
        setCargando={setEspera} btnTitulo={"Enviar"} setAviso={setAviso}
    > 
    <form  noValidate autoComplete="off" fullWidth>       
                   
        <Box  display="flex" flexDirection="row" style={{width:35+'rem'}} className={classes.root}>         
            <Box style={{ display: 'flex', flexDirection: 'column', marginTop:'.3em',marginRight:'2rem', width:"14rem"}}>
               {progresoEnvio<=0 ?
                <span> 
                    <input type="file" name="file" onChange={onChangeArchivos2} hidden id={`cargarArchivo`}
                        accept={accept}  />
                    <label htmlFor={`cargarArchivo`}>
                        <Button color="primary" variant="contained" size="small" component="span" 
                            style={{fontSize:12 , width:"12rem"}}
                        >
                            Seleccionar Documento
                        </Button>
                    </label>
                    <Typography color='primary' style={{fontSize:".8rem", marginTop:".2rem", marginLeft:"1rem"}}>
                        Tamaño maximo de 10MB
                    </Typography>
                </span>
                : <Box mt={2}>   <Progress progress={progresoEnvio}/></Box>}
                {nombreArchivo.corto ?
                    <Box mt={3}>
                    <Card  style={{marginRight:.5+'rem',paddingLeft:.3+'rem',width:"15rem",
                        paddingRight:.3+'rem',marginTop:.3+'rem',marginBottom:.3+'rem'}}        
                    >    
                        <Box display={"flex"} flexDirection="row" >                   
                        <Typography color={"primary"}> {nombreArchivo.corto} </Typography>  
                        <HighlightOffIcon size="small" color={"primary"} onClick={()=>borrarArchivo()} 
                            style={{marginLeft:.5+'rem',paddingBottom:.1+'rem',paddingTop:.1+'rem'}}  />   
                        </Box>                          
                    </Card>
                    </Box>
                :null}   
                
            </Box> 
            
            <Box display={"flex"} flexDirection={"column"}>
                <Box>
                    <TextField variant='outlined'
                        label="Descripción" id="descripcion-campo"
                        value={descripcion} name="descripcion" onChange={onChange}
                        size="small" style={{width:"15rem", marginLeft:.5+'rem'}} 
                    />
                </Box>
                <Box display={"flex"} style={{width:"16rem", marginLeft:.5+'rem', marginTop:"1rem" }} >
                    { listTipo.length!==0 ? selectTipo  :null  }                                                      
                </Box>
            </Box>
        </Box>     
     
    </form>
    </Modal>
  )
}

export default ModalArchivo